import { render } from "./BenchmarkManagerEditorNewQuestion.vue?vue&type=template&id=38ab054e"
import script from "./BenchmarkManagerEditorNewQuestion.vue?vue&type=script&lang=js"
export * from "./BenchmarkManagerEditorNewQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__